import useStore from '../../store'
import { FaUser, FaHome, FaExclamationTriangle, FaTruck } from 'react-icons/fa'
import { FaMoneyBillTrendUp } from "react-icons/fa6"
import { TbClockDollar } from "react-icons/tb"
import FloorCarIcon from '../common/FloorCarIcon'
import MobileNavItem from './MobileNavItem'
import { AiOutlineAudit } from 'react-icons/ai'
import {
  fieldAuditsTableEnabled,
  hubspotLiveChatEnabled,
  businessDevAmPortalEnabled,
  riskMitigationEnabled,
  vciPortalEnabled,
  carpoolEnabled
} from '../../utilities/featureFlags'
import useUserType from '../../hooks/useUserType'

export default function MobileNavItems() {
  const user = useStore((state) => state.user)
  const dealer = useStore((state) => state.dealer)
  const { isDealer, isEmployee } = useUserType()

  return (
    <div className={`lg:hidden flex items-start justify-evenly w-full mt-3 mb-0.5 pb-5`}>
      <MobileNavItem
        path='/'
        icon={<FaHome size={22} />}
      />

      {isEmployee &&
        <>
          {fieldAuditsTableEnabled &&
            <MobileNavItem
              path={'/audits'}
              icon={<AiOutlineAudit size={22} />}
            />
          }
          {vciPortalEnabled &&
            <MobileNavItem
              path={'/field_audits'}
              icon={<AiOutlineAudit size={22} />}
            />
          }
        </>
      }

      <MobileNavItem
        path='/account'
        icon={<FaUser size={22} />}
      />

      {isDealer &&
        <>
          <MobileNavItem
            path='/transfers'
            icon={<TbClockDollar size={22} />}
          />
          <MobileNavItem
            path='/blackbook'
            icon={<FloorCarIcon />}
          />
          {
            carpoolEnabled(dealer) &&
            <MobileNavItem
              path='/transportation'
              icon={<FaTruck size={22} />}
            />
          }
          {hubspotLiveChatEnabled(user) &&
            <div className='sm:hidden py-1.5 px-8 rounded'></div>
          }
        </>
      }
      {isEmployee &&
        <>
          {riskMitigationEnabled &&
            <MobileNavItem
              path={'/risk'}
              icon={<FaExclamationTriangle size={22} />}
            />
          }
          {businessDevAmPortalEnabled &&
            <MobileNavItem
              path={'/business_dev'}
              icon={<FaMoneyBillTrendUp size={22} />}
            />
          }
        </>
      }
    </div>
  )
}